import { ApolloError } from '@apollo/client'
import { Lot, LotRoutingState, LotViewName } from '../../../types/lot.interface'

export function getLotRoutingState(lot?: Lot | null, lotError?: ApolloError): LotRoutingState {
    if (lotError) {
        return LotRoutingState.GENERIC_ERROR
    }

    if (lot) {
        if (!lot.is_live) return LotRoutingState.NOT_LIVE_ERROR

        if (new Date(lot.earliest_booking_date) < new Date() && new Date(lot.end_of_live_date) < new Date()) {
            return LotRoutingState.LOT_END_OF_LIVE_ERROR
        }

        if (lot.active_features.length > 0) {
            const activeFeatures = lot.active_features.filter((feature) => feature.enabled)
            const isDailyFeature =
                activeFeatures.filter((feature) => feature.name.toLocaleLowerCase() === LotViewName.DAILY.toLowerCase())
                    .length === 1

            const isHourlyFeature =
                activeFeatures.filter(
                    (feature) => feature.name.toLocaleLowerCase() === LotViewName.HOURLY.toLowerCase()
                ).length === 1

            const earliestDateInFuture = new Date(lot.earliest_booking_date) > new Date()

            if (!isDailyFeature && isHourlyFeature && earliestDateInFuture) {
                return LotRoutingState.LOT_HOURLY_TOO_EARLY_ERROR
            }

            if (activeFeatures.length === 1) {
                const feature = activeFeatures[0]
                if (feature.name.toLowerCase() === LotViewName.DAILY.toLowerCase()) {
                    return LotRoutingState.DAILY
                }
                if (feature.name.toLowerCase() === LotViewName.HOURLY.toLowerCase()) {
                    return LotRoutingState.HOURLY
                }
                if (feature.name.toLowerCase() === LotViewName.NIGHTLY.toLowerCase()) {
                    return LotRoutingState.NIGHTLY
                }
            }
        }
    }

    return LotRoutingState.LOADING
}
